var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfigAppv = function SvgConfigAppv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "config_appv_svg__Capa_2",
    viewBox: "0 0 36.76 43.55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "config_appv_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.29.22 1.69 6.87A2.79 2.79 0 0 0 0 9.43v6.41c0 5.72 1.6 11.4 4.88 16.4 2.77 4.21 7.05 8.55 13.64 11.31 6.06-1.85 10.58-6.78 13.35-10.99 3.29-5.01 4.88-10.68 4.88-16.4V9.43c0-1.11-.66-2.12-1.69-2.56L19.47.22c-.7-.3-1.48-.3-2.18 0",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.38,
    cy: 19.38,
    r: 8.66,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: "5px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.38,
    cy: 19.38,
    r: 3.05,
    fill: "#fff"
  }))));
};
export default SvgConfigAppv;